// Default color palette for models
export const MODEL_COLORS = [
  "#4285F4", // Google blue
  "#0F9D58", // Google green
  "#7356BF", // Anthropic purple
  "#10A37F", // OpenAI green
  "#F4B400", // Google yellow
  "#E53935", // Google red
  "#7F3F98", // Purple
  "#F9AB00", // Orange
];
